/**
 * Enum of possible values in minutes for an order arrival tolerance.
 * @type {Readonly<{0: number, 15: number, 30: number, 60: number, 120: number}>}
 */
const OrderArrivalTolerances = Object.freeze({ 0: 0, 15: 15, 30: 30, 60: 60, 120: 120 })

export { OrderArrivalTolerances }
